import MobileDetect from 'mobile-detect'
import router from 'web-router'

import {
  getNamespaceSymbol,
} from 'web-utils'
const namespaceSymbol = getNamespaceSymbol() || 'gymcloud'

function getNormalizedPathname(): { pathname: string; isOldUrl: boolean } {
  const { pathname, hash } = window.location
  const isOldUrl = pathname === '/' && hash.startsWith('#')
  return {
    isOldUrl,
    pathname: isOldUrl ? `/${hash.replace('#', '')}` : pathname,
  };
}

const authRoutes = [
  '/login', '/forgot-password',
  '/reset', '/confirm',
]

const staticRoutes = [
  '/welcome',
  '/personal_workouts',
  '/workout_exercises',
  '/personal_programs',
  '/events',
  '/workout_events',
  '/users',
  '/payments',
  '/products',
  '/marketplace',
  '/videos',
  '/billing',
  '/exercises_folder',
  '/workout_templates_folder',
  '/warmups_folder',
  '/cooldowns_folder',
  '/program_templates_folder',
  '/clients',
  '/client_groups',
  '/messages',
  '/calendar',
  '/exercises',
  '/workout_templates',
  '/warmups',
  '/cooldowns',
  '/program_templates',
  '/personal_properties',
  '/search',
  '/tags',
  '/documents',
  '/documents_folder',
  '/personal_exercises',
  '/personal_warmups',
  '/personal_cooldowns',
  '/account',
]

export function initialRedirect(hasToken: boolean) {
  const md = new MobileDetect(window.navigator.userAgent)
  const { isOldUrl, pathname } = getNormalizedPathname()
  if (md.mobile()) {

    if (staticRoutes.includes(pathname)) {
      router.navigate(namespaceSymbol === 'ideafit' ? '/get_app' : '/use_app')
      return
    }

    if (namespaceSymbol !== 'strongfirst' && authRoutes.includes(pathname)) {
      router.navigate(namespaceSymbol === 'ideafit' ? '/get_app' : '/use_app')
      return
    }

    if (isOldUrl) {
      router.navigate(pathname)
      return
    }

    return
  }

  if (pathname === '/') {
    router.navigate('/welcome')
    return
  }

  if (hasToken && authRoutes.includes(pathname)) {
    router.navigate('/welcome')
    return
  }

  if (isOldUrl) {
    router.navigate(pathname);
  }
}
